// API configuration keys
export const API_CONFIG_KEYS = {
  apimContentHub: 'apimContentHub',
  apimBaseUrl: 'apimBaseUrl',
  authToken: 'authToken',
  apimFormApi: 'apimFormApi',
  apimMotorApi: 'apimMotorApi',
  apimNafNoApi: 'apimNafNoApi',
  apimVehicleDataApi: 'apimVehicleDataApi',
  apimMembershipApi: 'apimMembershipApi',
  apimNafCenterApi: 'apimNafCenterApi',
  apimTravelApi: 'apimTravelApi',
  apimMapsApi: 'apimMapsApi',
  external: 'external',
} as const;

// Default axios configuration
export const DEFAULT_AXIOS_CONFIG = {
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
} as const;

export const CLIENT_PLATFORM_HEADER = 'X-Client-Platform';

// HTTP Status Codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
} as const;

// Error messages
export const ERROR_MESSAGES = {
  API_ENDPOINT_NOT_FOUND: (apiType: string) => `API endpoint '${apiType}' not found in Redux store`,
  REQUIRED_CONFIG_NOT_FOUND: 'Required API configuration not found in Redux store',
} as const;
